import get from 'lodash/get';

const civilities = {
    'M.': 'Monsieur',
    'Mme.': 'Madame',
    'M. et Mme.': 'Monsieur et Madame',
    'M. et M.': 'Monsieur et Monsieur',
    'Mme. et Mme.': 'Madame et Madame',
    Société: 'Société',
};



const families = {
    'A renseigner': 'A renseigner',
    'Célibataire/Divorcé': 'Célibataire/Divorcé',
    'Célibataire/Divorcé en concubinage': 'Célibataire/Divorcé en concubinage',
    'veuf/ve avec enfant non issu du conjoint décédé': 'veuf/ve avec enfant non issu du conjoint décédé',
    'veuf/ve avec enfant issu du conjoint décédé': 'veuf/ve avec enfant issu du conjoint décédé',
    'Marié ou Pacsé': 'Marié ou Pacsé'
};



function formatCivilities(value: string) {
    return get(civilities, value, value);
}

export { civilities, formatCivilities, families };
